export type PageTitleKind = "default" | "login" | "callback";

export type BuildDocumentTitleOptions = {
  kind?: PageTitleKind;
  siteTitle: string;
  centerTitle?: string | null;
  pageTitle?: string | null;
  objectTitle?: string | null;
};

function normalizeTitlePart(value: string | null | undefined): string {
  return String(value || "").trim();
}

function dedupeTitleParts(parts: string[]): string[] {
  const normalized: string[] = [];
  for (const part of parts) {
    if (!part) continue;
    if (normalized.includes(part)) continue;
    normalized.push(part);
  }
  return normalized;
}

export function buildDocumentTitle({
  kind = "default",
  siteTitle,
  centerTitle,
  pageTitle,
  objectTitle,
}: BuildDocumentTitleOptions): string {
  const normalizedSiteTitle = normalizeTitlePart(siteTitle);
  const normalizedCenterTitle = normalizeTitlePart(centerTitle);
  const normalizedPageTitle = normalizeTitlePart(pageTitle);
  const normalizedObjectTitle = normalizeTitlePart(objectTitle);

  if (kind === "callback") {
    return normalizedSiteTitle;
  }

  if (kind === "login") {
    return dedupeTitleParts([normalizedPageTitle, normalizedSiteTitle]).join(" - ");
  }

  return dedupeTitleParts([
    normalizedObjectTitle,
    normalizedPageTitle,
    normalizedCenterTitle,
    normalizedSiteTitle,
  ]).join(" - ");
}

export type DetailObjectTitleCandidate =
  | string
  | number
  | null
  | undefined;

export type DetailObjectTitleSource = {
  business_label?: DetailObjectTitleCandidate;
  display_name?: DetailObjectTitleCandidate;
  name?: DetailObjectTitleCandidate;
  title?: DetailObjectTitleCandidate;
  identifier?: DetailObjectTitleCandidate;
  instanceIdentifier?: DetailObjectTitleCandidate;
  request_id?: DetailObjectTitleCandidate;
  id?: DetailObjectTitleCandidate;
};

function normalizeCandidate(value: DetailObjectTitleCandidate): string {
  return String(value ?? "").trim();
}

export function pickDetailObjectTitle(source: DetailObjectTitleSource | null | undefined): string {
  if (!source) return "";
  const candidates = [
    source.business_label,
    source.display_name,
    source.name,
    source.title,
    source.identifier,
    source.instanceIdentifier,
    source.request_id,
    source.id,
  ];
  for (const candidate of candidates) {
    const normalized = normalizeCandidate(candidate);
    if (normalized) return normalized;
  }
  return "";
}
